import React from 'react';

const RoundsLogo: React.FC<React.SVGProps<SVGSVGElement>> = ({
  height = '2.4rem',
  width = '2.4rem',
  ...props
}): React.ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 94 94"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>icon-rounds</title>
    <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Solution-PetGenus"
        transform="translate(-673.000000, -2141.000000)"
      >
        <g id="Group-7-Copy-5" transform="translate(552.000000, 2109.000000)">
          <g id="icon-rounds" transform="translate(121.000000, 32.000000)">
            <rect
              id="Rectangle"
              fill="#FFF2F2"
              x="0"
              y="0"
              width="94"
              height="94"
              rx="47"
            ></rect>
            <g id="network--4" transform="translate(20.000000, 20.000000)">
              <ellipse
                id="Oval"
                fill="#FF5B5B"
                fillRule="nonzero"
                cx="35.4373476"
                cy="43.875"
                rx="3.37498548"
                ry="3.375"
              ></ellipse>
              <ellipse
                id="Oval"
                fill="#FF5B5B"
                fillRule="nonzero"
                cx="35.4373476"
                cy="10.125"
                rx="3.37498548"
                ry="3.375"
              ></ellipse>
              <ellipse
                id="Oval"
                fill="#FF5B5B"
                fillRule="nonzero"
                cx="6.74997096"
                cy="27"
                rx="3.37498548"
                ry="3.375"
              ></ellipse>
              <path
                d="M47.2497967,20.25 C44.1805272,20.2593269 41.5047363,22.340098 40.7396185,25.3125 L33.5100621,25.3125 C33.0263685,23.3856526 31.7115455,21.773333 29.9214161,20.9118739 C28.1312867,20.0504149 26.0509386,20.0288856 24.2433645,20.8531125 L18.8830438,14.1534 C19.765028,12.9951913 20.2449458,11.5807904 20.2499129,10.125 C20.2499129,6.39707794 17.227848,3.375 13.4999419,3.375 C9.7720359,3.375 6.74997096,6.39707794 6.74997096,10.125 C6.74997096,13.8529221 9.7720359,16.875 13.4999419,16.875 C14.4514068,16.8725322 15.3913751,16.6669096 16.2569676,16.2718875 L21.6164445,22.9712625 C19.7946366,25.3478987 19.7946366,28.6514263 21.6164445,31.0280625 L16.2573051,37.7274375 C15.3915576,37.3326009 14.4514714,37.1272078 13.4999419,37.125 C9.7720359,37.125 6.74997096,40.1470779 6.74997096,43.875 C6.74997096,47.6029221 9.7720359,50.625 13.4999419,50.625 C17.227848,50.625 20.2499129,47.6029221 20.2499129,43.875 C20.2449704,42.4192055 19.76505,41.004797 18.8830438,39.8466 L24.2421832,33.147225 C26.0499434,33.9716912 28.1305844,33.9502536 29.9209733,33.0887143 C31.7113621,32.227175 33.0263615,30.6146226 33.5100621,28.6875 L40.7396185,28.6875 C41.6222458,32.0760032 44.9529345,34.2239571 48.4037619,33.6300895 C51.8545894,33.0362219 54.2756389,29.8984269 53.9747631,26.4098076 C53.6738873,22.9211884 50.7513468,20.244255 47.2497967,20.25 Z M10.1249564,10.125 C10.1249564,8.26103897 11.6359889,6.75 13.4999419,6.75 C15.3638949,6.75 16.8749274,8.26103897 16.8749274,10.125 C16.8749274,11.988961 15.3638949,13.5 13.4999419,13.5 C11.6368756,13.4978612 10.1270953,11.9880744 10.1249564,10.125 Z M13.4999419,47.25 C11.6359889,47.25 10.1249564,45.738961 10.1249564,43.875 C10.1249564,42.011039 11.6359889,40.5 13.4999419,40.5 C15.3638949,40.5 16.8749274,42.011039 16.8749274,43.875 C16.8727886,45.7380744 15.3630083,47.2478612 13.4999419,47.25 Z M26.9998839,30.375 C25.1359308,30.375 23.6248984,28.863961 23.6248984,27 C23.6248984,25.136039 25.1359308,23.625 26.9998839,23.625 C28.8638369,23.625 30.3748693,25.136039 30.3748693,27 C30.3727305,28.8630744 28.8629502,30.3728612 26.9998839,30.375 Z M47.2497967,30.375 C45.3858437,30.375 43.8748113,28.863961 43.8748113,27 C43.8748113,25.136039 45.3858437,23.625 47.2497967,23.625 C49.1137498,23.625 50.6247822,25.136039 50.6247822,27 C50.6226434,28.8630744 49.1128631,30.3728612 47.2497967,30.375 Z"
                id="Shape"
                fill="#FF5B5B"
                fillRule="nonzero"
              ></path>
              <rect
                id="_Transparent_Rectangle_"
                transform="translate(26.999884, 27.000000) rotate(180.000000) translate(-26.999884, -27.000000) "
                x="0"
                y="0"
                width="53.9997677"
                height="54"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default RoundsLogo;
